import { Briefcase, AlertTriangle, Lightbulb } from 'lucide-react';
import { NODE_HUE } from '@/lib/node-visuals';

// Respondent-facing config for the three draft item types. Hues come from the
// shared NODE_HUE so the chat, review screen, badges, canvas, and dot map all
// speak one colour language.
export const DRAFT_TYPE_CONFIG = {
  job: { label: 'Job', gloss: "what you're trying to get done", icon: Briefcase, hue: NODE_HUE.job },
  challenge: { label: 'Challenge', gloss: 'what gets in the way', icon: AlertTriangle, hue: NODE_HUE.challenge },
  opportunity: { label: 'Opportunity', gloss: 'what would make things better', icon: Lightbulb, hue: NODE_HUE.opportunity },
} as const;
